"use strict";

var PyDefUtils = require("PyDefUtils");

/**
id: linearpanel
docs_url: /docs/client/components/containers#linearpanel
title: LinearPanel
tooltip: Learn more about LinearPanel
description: |
    ```python
    lp = LinearPanel()
    lp.add_component(Label(text="Hello"))
    lp.add_component(Button(text="Click me"))
    ```

    This container arranges its child components vertically, each filling the whole width of the panel by default.

    It takes no extra arguments for `add_component`: each component is added to the bottom of the LinearPanel.

    The LinearPanel will expand vertically to fit its contents.

    ```python
    # self.linear_panel_1 is a LinearPanel
    lp.add_component(Button(text="Button"))
    # This label will be added above the Button.
    lp.add_component(Label(text="Label"), index=0)
    ```

    By default, components are added at the end of a LinearPanel.
    If you add an `index` layout parameter to the `add_component()` call, the component will be added at that index. Index 0 is the first element in the panel, 1 is the second, etc.
*/

module.exports = (pyModule) => {

    pyModule["LinearPanel"] = PyDefUtils.mkComponentCls(pyModule, "LinearPanel", {
        base: pyModule["Container"],

        properties: PyDefUtils.assembleGroupProperties(/*!componentProps(LinearPanel)!1*/ ["layout", "containers", "appearance", "tooltip", "user data"]),

        events: PyDefUtils.assembleGroupEvents("linear panel", /*!componentEvents(LinearPanel)!1*/ ["universal"]),

        element: (props) => (
            <PyDefUtils.OuterElement className="anvil-container" {...props}>
                <ul refName="lpul" className="linear-panel"></ul>
            </PyDefUtils.OuterElement>
        ),

        locals($loc) {
            // TODO: Add properties for orientation. Vertical for now.

            const ContainerElement = () => {
                return <li></li>;
            };

            /*!defMethod(_,component,[index=None])!2*/ "Add a component to this LinearPanel, in the 'index'th position. If 'index' is not specified, adds to the bottom."
            $loc["add_component"] = PyDefUtils.funcWithKwargs(function (kwargs, self, component) {
                pyModule["Container"]._check_no_parent(component);

                let celt;
                const element = component._anvil.element;
                const idx = kwargs["index"];

                return Sk.misceval.chain(
                    null,
                    () => {
                        if (component._anvil.metadata.invisible) {
                            return;
                        }

                        [celt] = <ContainerElement />;
                        celt.appendChild(element[0]);
                        const lpul = self._anvil.elements.lpul;
                        if (typeof idx === "number") {
                            if (idx < lpul.children.length) {
                                lpul.insertBefore(celt, lpul.children[idx]);
                                return;
                            }
                        }
                        lpul.appendChild(celt);
                    },
                    () => Sk.misceval.callsimOrSuspend(pyModule["Container"].prototype.add_component, self, component, kwargs),
                    () => {
                        // Now that we've added it to our components array, move it to the right position.
                        if (typeof idx === "number") {
                            const c = self._anvil.components.pop(); // pop off this new component (pushed on by super.add_component())
                            self._anvil.components.splice(idx, 0, c);
                        }
                        const rmFn = component._anvil.parent.remove;
                        component._anvil.parent.remove = () => {
                            if (celt) {
                                celt.remove();
                            }
                            return rmFn();
                        };
                        return Sk.builtin.none.none$;
                    }
                );
            });
        },
    });


};

/*!defClass(anvil,LinearPanel,Container)!*/

/*
 * TO TEST:
 *
 *  - Prop groups: layout, containers, appearance
 *  - Event groups: universal
 *  - Methods: add_component
 *
 */
